import clsx from "clsx";

export function ActionButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  const { children, className, ...rest } = props;

  return (
    <div className={clsx("lander__quiz__footer no-margin")}>
      <div className="lander__quiz__footer--next-btn">
        <div className="lander__quiz__button-container">
          <button
            className={clsx(
              "lander__quiz__button",
              "lander__quiz__button--selected",
              className
            )}
            {...rest}
          >
            {children}
          </button>
        </div>
      </div>
    </div>
  )
}
